const withCryptoInfo =
  (Component) =>
  ({ data, open, setOpen }) => {
    const listToRender = [
      { label: "Wallet Address", value: data?.walletAddress },
      { label: "Network", value: data?.chain },
    ];

    return <Component type="Crypto" listToRender={listToRender} open={open} setOpen={setOpen} />;
  };
export default withCryptoInfo;
